import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheck, Lock, Globe } from 'lucide-react';
export function HowItWorks() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const steps = [{
    number: '01',
    icon: ShieldCheck,
    title: 'Verifica tu identidad',
    description: 'Completa una verificación segura una sola vez.'
  }, {
    number: '02',
    icon: Lock,
    title: 'Controla tus datos',
    description: 'Decide qué información compartir y con quién. Tú tienes el control total de tu identidad digital.'
  }, {
    number: '03',
    icon: Globe,
    title: 'Accede en todas partes',
    description: 'Usa tu identidad verificada en múltiples aplicaciones y servicios sin repetir el proceso.'
  }];
  return <section id="soluciones" className="py-20 md:py-32 bg-navy-800/50" ref={ref} data-id="element-94">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-96">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-97">
            Cómo funciona
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-98">
            Tres pasos simples para una identidad digital segura y reutilizable
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-99">
          {/* Connection Lines */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-teal-500/20 to-transparent -translate-y-1/2" data-id="element-100"></div>

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.div key={step.number} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="relative" data-id="element-101">
                <div className="bg-navy-900 border border-teal-500/20 rounded-2xl p-8 hover:border-teal-500/40 transition-all group" data-id="element-102">
                  {/* Number Badge */}
                  <div className="absolute -top-4 left-8 bg-teal-500 text-navy-900 w-12 h-12 rounded-full flex items-center justify-center font-display font-bold text-lg" data-id="element-103">
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className="mb-6 mt-4" data-id="element-104">
                    <div className="w-16 h-16 bg-teal-500/10 rounded-xl flex items-center justify-center group-hover:bg-teal-500/20 transition-colors" data-id="element-105">
                      <Icon size={32} className="text-teal-500" data-id="element-106" />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-display font-semibold text-white mb-3" data-id="element-107">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed" data-id="element-108">
                    {step.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}